import { getChannelClient } from 'src/utils/messages/singleton'
import sliceObj from '../../utils/sliceObj'

const STATE_KEYS = [
  'icon',
  'currency_symbol',
  'amount',
  'description',
  'info',
  'widget_style',
  'pollInterval',
  'brand_color',
]

// Impact widget's inbound side of the channel. The shop calculator
// preview (CalculatorPreview.jsx) and any future host that wants to
// live-drive impact widget state pushes setWidgetState over the
// channel and we mirror the changes into preact state.
const API = app => {
  const handler = payload =>
    app.setState(sliceObj(payload, STATE_KEYS))

  return {
    init: () => getChannelClient().on('setWidgetState', handler),
    // The channel client's per-type Map only holds one handler at a
    // time, so terminate is a no-op for the singleton — but the
    // init/terminate surface stays so existing callers don't notice.
    terminate: () => {},
  }
}

export default API
